import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import api, { formatApiErrorDetail } from "./api";
import { AuthShell } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      toast.success(data.message);
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Forgot Password" subtitle="Enter your email and we'll send a reset link.">
      {sent ? (
        <div data-testid="forgot-sent" className="text-sm leading-relaxed" style={{ color: "#94A3B8" }}>
          If an account exists for <span className="text-white">{email}</span>, a password reset link has been sent.
          The link is valid for 1 hour.
          <div className="mt-6">
            <Link to="/portal/login" className="mono-label hover:text-cyan" style={{ color: "#00F0FF" }}>← Back to login</Link>
          </div>
        </div>
      ) : (
        <>
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div>
              <label className="mono-label block mb-2" style={{ color: "#94A3B8" }}>Email</label>
              <input type="email" required className="field" placeholder="you@a3networks.co.in"
                value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="group w-full flex items-center justify-center gap-2 bg-[#0066FF] hover:bg-[#00F0FF] text-white hover:text-[#060A14] px-6 py-3.5 mono-label transition-colors duration-300 disabled:opacity-60">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <>Send Reset Link <ArrowRight size={16} className="cta-arrow" /></>}
            </button>
          </form>
          <div className="mt-5">
            <Link to="/portal/login" className="mono-label hover:text-cyan transition-colors" style={{ color: "#64748B" }}>← Back to login</Link>
          </div>
        </>
      )}
    </AuthShell>
  );
}
